import React from 'react';
import clsx from 'clsx';
import LogoImg from "assets/images/logo.png";
import PropTypes from "prop-types";
import {AppRoutes} from "application/index";
import {HeaderActions} from "../header-actions/HeaderActions";
import {HeaderDrawerProvider, MobileDrawer} from "presentation/common/components/layout/mobile-drawer";
import {useHistory} from "react-router-dom";

import styles from "./Header.module.scss";

export const Header = (props) => {
  const history = useHistory();

  return (
    <HeaderDrawerProvider>
      <header className={clsx(styles.header)}>
        <nav className={clsx(styles.navBar, styles.bgHeader)}>
          <div className={styles.logoContainer}>
            <img className={styles.headerLogo} src={LogoImg} alt="logo" onClick={() => history.push(AppRoutes.home)}/>
            <MobileDrawer  {...props} />
          </div>

          <h3 className="text-primary">{props.title}</h3>

          <div id="header-actions-container"/>
          <HeaderActions {...props} className={styles.options}/>
        </nav>
      </header>
    </HeaderDrawerProvider>
  );
};

Header.propTypes = {
  isAuthenticated: PropTypes.bool,
  onSignOut: PropTypes.func,
  userInfo: PropTypes.any,
  title: PropTypes.string,
}

Header.defaultProps = {
  isAuthenticated: false,
  onSignOut: () => {},
  userInfo: {},
  title: 'INSCRIPCIÓN VEHICULAR'
}

export default React.memo(Header);
